import { ErrorView } from "@gearbox-protocol/ui-kit";

export function NotFoundPage() {
  return (
    <ErrorView
      status={404}
      message="Page not found"
      backButton={{
        text: "Back to Home",
        href: "/",
      }}
    />
  );
}
